import { useContext } from 'react';
import { AuthContext } from './authContext.js';
import { PreviewProfileContext } from './previewProfileContext.js';

// Display-only personalization; never used as an issuer-verified cardholder identity.
export function useCardDisplayName(): string {
  const auth = useContext(AuthContext);
  const preview = useContext(PreviewProfileContext);
  return (
    preview?.displayName.trim() ||
    auth?.userProfile?.displayName?.trim() ||
    auth?.currentUser?.displayName?.trim() ||
    'Your Name'
  );
}
